export const NEXT_GEAR_CAPITAL_URL =
  'https://nextgearcapital.co.uk/the-stock-vault/?utm_campaign=the_stock_vault&utm_medium=landing_page&utm_source=the_stock_vault';
